export default "__VITE_ASSET__CX_90pNF__"